import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import ChartDetails from './ChartDetails.json';
import { getLoadingTemplate, scrollToViewById } from '../../helpers/GlobalFunctions';
import ErrorMsgBlockComponent from '../Error/ErrorMessageBlock';
import AnalyticsScatterChartTSA from './AnalyticsScatterChartTSA';

export default class TSAScatterChartsComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ArmLength: null,
			ArmLateralization: null,
			ArmAHD: null
		}
	}

	componentDidMount() {
		const { chartList, allAnalyticsData, propState } = this.props;
		if (allAnalyticsData && allAnalyticsData.seriesdata && allAnalyticsData.seriesdata.length) {
			const stateObj = {};
			chartList.forEach(chart => {
				let seriesData = allAnalyticsData.seriesdata.find(x => x.name === chart) || {};
				let chartData = {
					caseInfo: seriesData.series && seriesData.series.length ? allAnalyticsData.caseInfo : [],
					name: seriesData.name,
					series: seriesData.series && seriesData.series.length ? seriesData.series : []
				};
				stateObj[chart] = chartData;
			});
			this.setState({ ...stateObj });
			scrollToViewById(propState?.graphID)
		}
	}

	/**
	 * @description Function to define template for no data scenario
	 * @returns Template showing no data text
	 * @memberof CaseAnalyticsComponent
	 */
	noDataTemplate(chartName) {
		return (
			<div className="chart-blocks">
				<h3 className="text-center">{chartName}</h3>
				<ErrorMsgBlockComponent noData={true} />
			</div>
		)
	}

	/**
	 * @description Function to define template for error scenario
	 * @returns Template showing error message
	 * @memberof CaseAnalyticsComponent
	 */
	errorTemplate(chartName, errorObj) {
		return (
			<div className="chart-blocks">
				<h3 className="text-center">{chartName}</h3>
				<ErrorMsgBlockComponent errorObject={errorObj} />
			</div>
		)
	}

	render() {
		const { analyticsError } = this.props;
		const { ArmLength, ArmLateralization, ArmAHD } = this.state;

		return (
			<>
				{/* Arm Length view */}
				<div id={ChartDetails.armLength.id}>
					<LazyLoad height={432}>
						{ArmLength ?
							(ArmLength.caseInfo && ArmLength.caseInfo.length ?
								<AnalyticsScatterChartTSA
									spacingRight={0}
									legendMargin={49}
									analyticsData={ArmLength}
									showTextInToolTip={true}
									chartDetails={ChartDetails.armLength}
									showUnit={true}
									unit="°"
								/>
								: this.noDataTemplate(ChartDetails.armLength.graphTitle))
							: analyticsError
								? this.errorTemplate(ChartDetails.armLength.graphTitle, analyticsError)
								: getLoadingTemplate()}
					</LazyLoad>
				</div>

				{/* Lateralization View */}
				<div id={ChartDetails.armLateralization.id}>
					<LazyLoad height={432} once offset={100}>
						{ArmLateralization ?
							(ArmLateralization.caseInfo && ArmLateralization.caseInfo.length ?
								<AnalyticsScatterChartTSA
									spacingRight={0}
									legendMargin={49}
									analyticsData={ArmLateralization}
									showTextInToolTip={true}
									chartDetails={ChartDetails.armLateralization}
									showUnit={true}
									unit="°"
								/>
								: this.noDataTemplate(ChartDetails.armLateralization.graphTitle))
							: analyticsError
								? this.errorTemplate(ChartDetails.armLateralization.graphTitle, analyticsError)
								: getLoadingTemplate()}
					</LazyLoad>
				</div>

				{/* AHD View */}
				<div id={ChartDetails.armAHD.id}>
					<LazyLoad height={432} once offset={100}>
						{ArmAHD ?
							(ArmAHD.caseInfo && ArmAHD.caseInfo.length ?
								<AnalyticsScatterChartTSA
									spacingRight={0}
									legendMargin={49}
									analyticsData={ArmAHD}
									showTextInToolTip={true}
									chartDetails={ChartDetails.armAHD}
									showUnit={true}
									unit="°"
								/>
								: this.noDataTemplate(ChartDetails.armAHD.graphTitle))
							: analyticsError
								? this.errorTemplate(ChartDetails.armAHD.graphTitle, analyticsError)
								: getLoadingTemplate()}
					</LazyLoad>
				</div>
			</>
		);
	}
}
